import { AutoFocusInside } from "react-focus-lock";

import { ConfirmDialogBase, Dialog } from "@smartrent/shared-ui";

import type { ConfirmDialogBaseProps } from "@smartrent/shared-ui";

export interface ConfirmDialogProps
  extends Omit<ConfirmDialogBaseProps, "Dialog"> {}

/**
 * A pre-configured Dialog component that replicates the UI and functionality of window.confirm().
 *
 * example: https://smartrent-ui.com/components/general/confirm-dialog
 */
export function ConfirmDialog(props: ConfirmDialogProps) {
  return (
    <ConfirmDialogBase
      AutoFocusInside={AutoFocusInside}
      Dialog={Dialog}
      {...props}
    />
  );
}
